export const fr = {
  dashboardPage: {
    meta: { title: 'Tableau de bord' },
    hero: {
      eyebrow: 'Tableau de bord',
      heading_main: 'Des rapports prêts pour la direction,',
      heading_em: "en quelques secondes",
      lead: "Heures bénévoles et impact — affichés dès la fin d'un quart. Sans analyste et sans marathon PowerPoint.",
    },
    availStrip: "Données en direct de chaque quart, en temps réel.",
    ask: {
      name: 'Interroger le tableau de bord',
      status: 'Accès anticipé',
      headline: 'Questions en langage naturel, réponses prêtes pour la direction',
      desc: "Oubliez le labyrinthe des feuilles de calcul. Tapez la question que vient de poser votre DRH ou responsable RSE — l'IA extrait les chiffres, analyse la tendance et cite chaque source utilisée.",
      features: [
        "Requêtes en langage naturel sur les heures, les dollars, les causes et les équipes",
        "Chaque chiffre est cliquable — remonte jusqu'aux données brutes du quart",
        'Un clic pour "rédiger une note de direction" ou "formater pour le deck du conseil"',
        "Les questions sauvegardées deviennent des rapports récurrents dans votre boîte mail",
      ],
      cta: 'Essayez avec vos données →',
      visual: {
        channel: 'Ask Purposely',
        tabLabel: 'IA',
        meta: "à l'instant",
        question: "Comment les heures du T1 se comparent-elles à l'an dernier, et quelle équipe a tiré la hausse ?",
        answer: "En <strong>T1 2026</strong>, votre équipe a cumulé <strong>2 847 heures</strong> avec 196 bénévoles — soit <strong>+34 %</strong> de plus qu'au T1 2025 (2 127 h). La hausse vient principalement de l'<strong>Ingénierie</strong>, passée de 312 h → 614 h (+97 %) après la série de nettoyages à Stanley Park.",
        sourcesLabel: 'Sources :',
        btn1: 'Rédiger une note de direction',
        btn2: 'Formater pour le deck du conseil',
        btn3: 'Sauvegarder comme récurrent',
      },
    },
    kpi: {
      name: 'KPIs en direct & tendances',
      status: "En direct | Mis à jour en temps réel",
      headline: 'Les chiffres que votre responsable RSE vérifie chaque lundi',
      desc: "Un tableau de bord unique pour les heures enregistrées, les bénévoles actifs, les heures d'événements et le taux de retour — ventilés par équipe, lieu, cause ou organisme. Les courbes de tendance se mettent à jour dès la fin d'un quart.",
      features: [
        'Filtrer par équipe, région, cause ou département en un clic',
        "Comparaisons d'une année sur l'autre et d'un trimestre sur l'autre intégrées",
        "Suivre le taux de participation, le taux de retour et les nouveaux bénévoles",
      ],
      cta: 'Explorer les métriques →',
      visual: {
        channel: 'Aperçu · T1 2026',
        meta: 'Toutes les équipes · Cumul annuel',
        chartTitle: 'Heures par mois',
        labelHours: 'Heures',
        labelVolunteers: 'Bénévoles',
        labelReturnRate: 'Taux de retour',
        labelDollarEquivalent: 'Valeur équivalente',
        leg2026: '2026',
        leg2025: '2025',
      },
    },
    cause: {
      name: 'Causes & ODD',
      status: 'En direct',
      headline: "Voyez où l'impact a atterri",
      desc: "Analysez les causes privilégiées par votre équipe et extrayez les données pour prendre les bonnes décisions",
      features: [
        "Repérez les causes sous-représentées avant votre bilan d'impact",
        "Comparez la répartition des causes entre bureaux, BU ou exercices fiscaux",
      ],
      cta: 'Cartographier vos causes →',
      visual: {
        channel: 'Causes · T1 2026',
        meta: '2 847 heures',
        chartTitle: 'Heures par cause',
        donutLabel: 'Heures',
        c1: 'Sécurité alimentaire',
        c2: 'Environnement',
        c3: "Éducation & jeunesse",
        c4: 'Logement & abri',
        sdg2: 'Faim zéro',
        sdg4: 'Éducation',
        sdg11: 'Communautés',
        sdg13: "Action climatique",
      },
    },
    teams: {
      name: 'Équipes & exports',
      status: 'En direct',
      headline: "Émulation amicale, exports prêts pour l'audit",
      desc: "Maintenez l'engagement des équipes tout au long du trimestre. Quand vient l'heure du rapport, exportez tout en un clic — dans les formats déjà utilisés par vos équipes financières et communication.",
      features: [
        "Classements par équipe selon les heures ou le taux de participation",
        "Exports en un clic en CSV pour Sheets et Excel",
        "Accédez aux dernières activités de votre entreprise, en temps réel",
      ],
      cta: 'Exporter un rapport exemple →',
      visual: {
        channel: 'Classement des équipes',
        meta: 'Par heures · T1 2026',
        exp1: 'Instantané PDF pour le conseil',
        exp2: 'CSV',
        exp3: 'GRI 413',
        exp4: 'Workiva',
        exp5: 'API',
      },
    },
    faq: {
      heading: 'Rapports, exports & données',
      items: [
        {
          q: "Quels formats d'export prenez-vous en charge ?",
          a: "CSV pour l'instant. Les formats GRI 413, B Corp et Workiva sont sur la feuille de route.",
        },
        {
          q: 'Qui peut voir quoi dans le tableau de bord ?',
          a: "L'accès au tableau de bord est réservé aux administrateurs. Les responsables d'équipe et les employés voient leur propre activité via leurs vues Purposely habituelles — la suite de rapports complète reste entre les mains de votre administrateur RSE ou RH.",
        },
        {
          q: 'À quelle fréquence les données sont-elles actualisées ?',
          a: "En temps réel. Dès qu'un quart est enregistré, il est reflété dans votre tableau de bord. Aucun traitement différé, sans attendre les chiffres du lundi.",
        },
      ],
    },
    cta: {
      heading_main: 'Visualisez votre impact,',
      heading_em: 'narré automatiquement',
      sub: "Réservez une démo de 20 minutes et nous connecterons un jeu de données en direct pour que vous puissiez interroger le tableau de bord librement.",
      button: 'Réserver une démo →',
    },
  },
}
